/**
 * @file Route: register
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "./index.scss";
import "layouts/main";
import { replaceFragment } from "@olmokit/core/fragments";
import { AuthRegister } from "components/Form/Auth/Register";
import { globalData } from "@olmokit/core/data";

console.log("Route register/index.js mounted.");

const route = globalData.route;

replaceFragment("registerForm", "components.FormAuthRegister", {route: route}).then(() => AuthRegister());